module.exports = __webpack_public_path__ + "img/genswell_3_1.caba2e4a.png";